import React, { useCallback, useEffect, useState } from "react";
import { GoogleMap, Marker as GoogleMapMarker } from "@react-google-maps/api";
import { useGoogleMaps } from "../../context/GoogleMapsContext";
import useStyles from "../Form/formStyles";

const Marker = ({ lat, lng, onDragEnd, isReadOnly }) => (
  <GoogleMapMarker
    position={{ lat, lng }}
    alt={"marker"}
    draggable={!isReadOnly}
    onDragEnd={!isReadOnly ? onDragEnd : undefined}
  />
);

const Map = ({ label, lat, lng, onLocationChange, isReadOnly = false }) => {
  lat = lat || 39.0742; // Default latitude
  lng = lng || 21.8243; // Default longitude

  const [map, setMap] = useState(null);
  const [userMarker, setUserMarker] = useState(null);
  const [geocoder, setGeocoder] = useState(null);
  const { isLoaded } = useGoogleMaps();
  const styles = useStyles();

  useEffect(() => {
    if (isLoaded && window.google) {
      setGeocoder(new window.google.maps.Geocoder());
    }
  }, [isLoaded]);

  useEffect(() => {
    if (lat && lng) {
      setUserMarker({ lat, lng });
    }
  }, [lat, lng]);

  useEffect(() => {
    if (map && userMarker) {
      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend(
        new window.google.maps.LatLng(userMarker.lat, userMarker.lng)
      );
      map.fitBounds(bounds);
    }
  }, [map, userMarker]);

  const onLoad = useCallback(
    function callback(map) {
      if (lat && lng) {
        const bounds = new window.google.maps.LatLngBounds();
        bounds.extend(new window.google.maps.LatLng(lat, lng));
        map.fitBounds(bounds);
      }
      setMap(map);
    },
    [lat, lng]
  );

  const onUnmount = useCallback(function callback(_map) {
    setMap(null);
  }, []);

  const onMapClick = (e) => {
    if (!isReadOnly && e.latLng) {
      const newLatLng = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      setUserMarker(newLatLng);
      handleReverseGeocode(newLatLng);
    }
  };

  const handleMarkerDragEnd = (e) => {
    if (e.latLng) {
      const newLatLng = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      setUserMarker(newLatLng);
      handleReverseGeocode(newLatLng);
    }
  };

  const handleReverseGeocode = ({ lat, lng }) => {
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results && results[0]) {
        const address = results[0].formatted_address;
        onLocationChange({ lat, lng, address });
      }
    });
  };

  return isLoaded ? (
    <div style={{ height: "300px", width: "100%", marginBottom: 24 }}>
      <span className={styles.label}>{label}</span>
      <GoogleMap
        mapContainerStyle={{
          height: "300px",
          width: "100%",
          borderRadius: "8px",
        }}
        center={userMarker || { lat, lng }}
        zoom={16}
        onLoad={onLoad}
        onUnmount={onUnmount}
        onClick={!isReadOnly ? onMapClick : undefined}
      >
        {userMarker ? (
          <Marker
            lat={userMarker.lat}
            lng={userMarker.lng}
            onDragEnd={handleMarkerDragEnd}
            isReadOnly={isReadOnly}
          />
        ) : null}
      </GoogleMap>
    </div>
  ) : null;
};

export default Map;
